// src/tenant/TenantApp.jsx
import { useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { CircularProgress, Box } from '@mui/material';

import { createKeycloak } from './keycloakFactory';
import { setKeycloak } from './keycloakSingleton';
import { AuthProviderKC } from '../context/AuthContext';
import { BootstrapProvider } from '../context/BootstrapContext'; // ⟵ add
import InnerRoutes from '../routes/InnerRoutes';

export default function TenantApp() {
    const { tenant } = useParams();
    const [kcReady, setKcReady] = useState(false);

    // ① Instância estável por tenant
    const keycloak = useMemo(() => {
        const kc = createKeycloak(tenant);
        setKeycloak(kc);
        return kc;
    }, [tenant]);

    // ② Guarda a URL exata apenas uma vez (para voltar onde o usuário estava)
    const initialRedirectUriRef = useRef(null);
    if (!initialRedirectUriRef.current) {
        const origin = window.location.origin;
        const path = window.location.pathname + (window.location.search || '');
        // se já está dentro do tenant, preserva a rota completa
        initialRedirectUriRef.current = path.startsWith(`/${tenant}/`)
            ? `${origin}${path}`
            : `${origin}/${tenant}`;
    }

    // ③ Marca como pronto quando autenticar
    const handleEvent = (event) => {
        if (
            event === 'onAuthSuccess' ||
            (event === 'onReady' && keycloak.authenticated)
        ) {
            setKcReady(true);
        }
    };

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
                onLoad: 'login-required',
                pkceMethod: 'S256',
                redirectUri: initialRedirectUriRef.current, // ⟵ volta pra página exata
                checkLoginIframe: false,
                silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
            }}
            onEvent={handleEvent}
            LoadingComponent={
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100vh' }}
                >
                    <CircularProgress />
                </Box>
            }
        >
            {kcReady && (
                <AuthProviderKC>
                    {/* ④ Assim que o SSO concluir, o provider chama POST /api/{tenant}/bootstrap */}
                    <BootstrapProvider>
                        <InnerRoutes />
                    </BootstrapProvider>
                </AuthProviderKC>
            )}
        </ReactKeycloakProvider>
    );
}
